import Hotspots from '@modules/Hotspots';

export default class LifestyleTileGrid {
  constructor(context) {
    if (context.querySelector('[data-props-hotspot]')) {
      //set splide container to overflow visible for the popup
      this.initializeHotspots(context);
    }
  }
  initializeHotspots(context) {
    context.querySelector('.lifestyle-tile__container').classList.add('overflow-visible');
    //initialize individual hotspots
    context.querySelectorAll('[data-props-hotspot]')?.forEach((tileImage) => {
      const hotspotJSON = tileImage.getAttribute('data-props-hotspot');
      tileImage.parentNode.classList.add('overflow-visible');
      new Hotspots(tileImage, JSON.parse(hotspotJSON));
    });
  }
}
